// extracted by mini-css-extract-plugin
module.exports = {"landingItems":"_fedc4244","landingItem":"_42702677","isHorizontal":"_79651341","spinner":"_9401d518","isUnpurchasable":"_7eaff2e0"};